var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgXIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.071 13.1855C15.5917 13.7061 15.5917 14.5504 15.071 15.0711C14.5503 15.5918 13.7061 15.5918 13.1854 15.0711L7.99996 9.88561L2.81452 15.071C2.29382 15.5917 1.4496 15.5917 0.928899 15.0711C0.408199 14.5504 0.4082 13.7061 0.928899 13.1854L6.11434 7.99999L0.928901 2.81455C0.408201 2.29385 0.408201 1.44963 0.9289 0.928935C1.4496 0.408237 2.29382 0.408237 2.81452 0.928936L7.99996 6.11437L13.1854 0.928917C13.7061 0.408218 14.5503 0.408217 15.071 0.928916C15.5917 1.44961 15.5917 2.29383 15.071 2.81453L9.88558 7.99999L15.071 13.1855Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/x-icon.618d8d9a.svg";
export { ForwardRef as ReactComponent };